var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-content",class:_setup.host},[_c('MenuSideBar'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('SnackbarContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }